import params from '../../../common/params/access-token';

export default params;
